/**
 * Appointment, like test drive
 */
export interface Appointment {
    /**
     * The YYYY-MM-DD formated date of the appointment.
     */
    date: string;
    /**
     * The time-frame for the appointment.
     */
    time: AppointmentTime;
    /**
     * True means a delivery to the customer's home, false means pick up at the dealership.
     */
    appointment_approved?: boolean;
}

export enum AppointmentTime {
    InTheMorning = "in the morning",
    InTheAfternoon = "in the afternoon",
    InTheEvening = "in the evening",
}
